/**
 * Geolocation helper for accident-flow photo capture.
 *
 * Resolves to null on permission denied / unavailable / timeout instead of
 * rejecting — a missing geo should not block the flow.
 */

export function getGeo(): Promise<{ lat: number; lng: number } | null> {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 30_000 },
    );
  });
}
